export default __webpack_public_path__ + "static/media/tyrfing_is_in_FEAR.cf1a8325.png";